import { useQuery } from '@tanstack/react-query'
import { rankingKeys } from '@!/Api/queryKeys'
import { getRankingApi } from '@!/Api/ranking'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useRanking = (rankingType, page, fetchType = null) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  return useQuery({
    queryKey: rankingKeys.filtered(safeSearch, rankingType, page, fetchType),
    queryFn: async () => {
      return await getRankingApi(safeSearch, rankingType, page, fetchType)
    },
    keepPreviousData: true,
    enabled: !!rankingType,
  })
}
